// extracted by mini-css-extract-plugin
module.exports = {"text":"text__-evQN","loading":"loading__sSXsK","icon":"icon__lmFEh","button-loader":"button-loader__Cn-rg"};